export default "__VITE_ASSET__CO9KmfUq__"